import React, { useEffect, useState } from "react";
import DisplayAddress from "./displayAddress";
import Enums from "./enums";
import AvailableBudget from "./availableBudget";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Loading from "./loading";
import { useMemo } from "react";
// @ts-ignore
import { WBMSelectionCard } from "wbm-selection-card";
// @ts-ignore
import { WBMLoader } from "wbm-loader";
// @ts-ignore
import { Button } from "wbm-inputs";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const manage_addresses_path = '/manage-addresses';

export interface IAddressListProps {
  addresses: any[];
  selectedAddressId: string;
  onDoneClick: (addressId: string) => void;
  displaySortView: boolean;
  manageAddressesUrl: string;
  sortOrder: string;
  onSelectedSortClick: (e: any) => void;
  showAvailableBudget: boolean;
  displayDeliveryDisclaimer: boolean;
  usePaging: boolean;
  sortedAndFilteredDeliveryAddressesLoading: boolean;
  sortedAndFilteredDeliveryAddressesError: boolean;
}

export const AddressList = (props: IAddressListProps) => {
  const sortCollection = [
    {
      name: "A to Z",
      sortOrder: Enums.SortOrder.Ascending.toString(),
    },
    {
      name: "Z to A",
      sortOrder: Enums.SortOrder.Descending.toString(),
    },
  ];

  let [selectedAddressId, setSelectedAddressId] = useState<string>(
    props.selectedAddressId,
  );

  useEffect(() => {
    if (props.selectedAddressId !== selectedAddressId) {
      setSelectedAddressId(props.selectedAddressId);
    }
  }, [props.selectedAddressId]);

  const isLoading = useMemo(() => {
    return props.usePaging && props.addresses.length === 0;
  }, [props.addresses, props.usePaging]);

  const onSelectedAddressClick = (selectedAddressId: string) => {
    setSelectedAddressId(selectedAddressId);

    props.onDoneClick(selectedAddressId);
  };

  const hasDeliveryAddresses = useMemo(() => {
    return !isLoading && props.addresses.length > 0;
  }, [isLoading, props.addresses]);

  return (
    <>
      {props.displaySortView && (
        <>
          {sortCollection.map((sort, index) => {
            return (
              <WBMSelectionCard
                selected={props.sortOrder === sort.sortOrder}
                selectedId={sort.sortOrder}
                key={sort.sortOrder}
                onClick={props.onSelectedSortClick}
              >
                <span>{sort.name}</span>
              </WBMSelectionCard>
            );
          })}
        </>
      )}
      {(props.sortedAndFilteredDeliveryAddressesLoading ||
        props.sortedAndFilteredDeliveryAddressesError) && (
        <WBMLoader hasError={props.sortedAndFilteredDeliveryAddressesError} />
      )}
      {!isLoading && !hasDeliveryAddresses && (
        <>
          You do not have any Delivery Addresses assigned to your account.
          <div className="add-address-btn">
            <Button
              className="btn-primary w-100"
              onClick={() => {
                if (props.manageAddressesUrl.endsWith(manage_addresses_path)) {
                  sessionStorage.setItem("openAddAddressSlideout", "true");
                }
                window.location.href = props.manageAddressesUrl;
              }}
            >
              <AddCircleOutlineIcon />
              ADD ADDRESS
            </Button>
          </div>
        </>
      )}
      {isLoading && (
        <span className="shipping-loading">
          <Loading />
        </span>
      )}
      {!isLoading &&
        props.displayDeliveryDisclaimer &&
        !props.displaySortView &&
        hasDeliveryAddresses && (
          <div>
            <span className="delivery-location-alert">
              <ErrorOutlineIcon />
              <span className="delivery-location-alert-text">
                Delivery options, speeds and product availability may vary for
                different locations.
              </span>
            </span>
          </div>
        )}
      {!isLoading && !props.displaySortView && hasDeliveryAddresses && (
        <>
          <div className="select-header">
            <div className="row">
              <div className="col text-left">
                <span>
                  <b>Select Address</b>
                </span>
              </div>
              <div className="col text-right">
                {props.manageAddressesUrl && (
                  <a href={props.manageAddressesUrl}>Manage Addresses</a>
                )}
              </div>
            </div>
          </div>
          <div className="select-body">
            {props.addresses &&
              props.addresses.length > 0 &&
              props.addresses.map((address, index) => {
                return (
                  <WBMSelectionCard
                    id={"selected-address-option-" + index.toString()}
                    selected={
                      selectedAddressId.toString() === address.id.toString()
                    }
                    selectedId={address.id.toString()}
                    key={address.id}
                    onClick={onSelectedAddressClick}
                    subDisplay={
                      props.showAvailableBudget && (
                        <AvailableBudget
                          availableBudget={
                            address.budgetRemaining
                              ? address.budgetRemaining
                              : "0"
                          }
                        />
                      )
                    }
                  >
                    <DisplayAddress address={address} displayFullAddress />
                  </WBMSelectionCard>
                );
              })}
          </div>
        </>
      )}
    </>
  );
};
